module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row prop-detail\">\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"checkbox\" name=\"buttonPosition\" value=\"buttonPosition\" ")
    ; __append(escapeFn( buttonPosition ))
    ; __append(" class=\"form-radio-group\"/> \r\n        <label class=\"form-group-label\">Position button on top</label>\r\n    </div>\r\n</div>")
  }
  return __output;

}